import React from "react"
import { useTranslation } from "react-i18next"
import { GameMode } from "../../../../../types/enum/Game"
import { RANKED_ENTRY_FEE, WHALE_RANKED_ENTRY_FEE, RANKED_DUOS_ENTRY_FEE } from "../../../../../config/game/ranked"
import { useAppSelector } from "../../../hooks"
import { Modal } from "../modal/modal"
import "./room-selection-menu.css"

export function RoomSelectionMenu(props: {
  show: boolean
  onClose: () => void
  onSelectMode: (mode: GameMode) => void
}) {
  const { t } = useTranslation()
  const profile = useAppSelector((state) => state.network.profile)
  const usdcBalance = profile?.usdcBalance || 0
  const canPlayRanked = usdcBalance >= RANKED_ENTRY_FEE
  const canPlayWhaleRanked = usdcBalance >= WHALE_RANKED_ENTRY_FEE
  const canPlayRankedDuos = usdcBalance >= RANKED_DUOS_ENTRY_FEE

  const handleRankedClick = () => {
    if (canPlayRanked) {
      props.onSelectMode(GameMode.RANKED)
    }
  }

  const handleWhaleRankedClick = () => {
    if (canPlayWhaleRanked) {
      props.onSelectMode(GameMode.WHALE_RANKED)
    }
  }

  const handleRankedDuosClick = () => {
    if (canPlayRankedDuos) {
      props.onSelectMode(GameMode.RANKED_DUOS)
    }
  }

  return (
    <Modal
      show={props.show}
      onClose={props.onClose}
      className="room-selection-menu"
      header={t("new_game")}
      body={
        <ul>
          <li
            className={`my-box ranked-mode ${!canPlayRanked ? "disabled" : ""}`}
            onClick={handleRankedClick}
          >
            <img
              src="assets/ui/game_modes/ranked.png"
              alt={t(`game_modes.${GameMode.RANKED}`)}
              draggable="false"
            />
            <h2>{t(`game_modes.${GameMode.RANKED}`)}</h2>
            <p>{t(`game_modes_descriptions.${GameMode.RANKED}`)}</p>
            <div className="entry-fee-badge">{t("ranked_entry_fee")}</div>
            {!canPlayRanked && (
              <div className="insufficient-funds">
                {t("insufficient_funds_ranked")}
              </div>
            )}
          </li>
          <li
            className={`my-box ranked-mode ${!canPlayWhaleRanked ? "disabled" : ""}`}
            onClick={handleWhaleRankedClick}
          >
            <img
              src="assets/ui/game_modes/whale_ranked.png"
              alt={t(`game_modes.${GameMode.WHALE_RANKED}`)}
              draggable="false"
            />
            <h2>{t(`game_modes.${GameMode.WHALE_RANKED}`)}</h2>
            <p>{t(`game_modes_descriptions.${GameMode.WHALE_RANKED}`)}</p>
            <div className="entry-fee-badge">{t("whale_ranked_entry_fee")}</div>
            {!canPlayWhaleRanked && (
              <div className="insufficient-funds">
                {t("insufficient_funds_whale_ranked")}
              </div>
            )}
          </li>
          <li
            className={`my-box ranked-mode ${!canPlayRankedDuos ? "disabled" : ""}`}
            onClick={handleRankedDuosClick}
          >
            <img
              src="assets/ui/game_modes/ranked_duos.png"
              alt={t(`game_modes.${GameMode.RANKED_DUOS}`)}
              draggable="false"
            />
            <h2>{t(`game_modes.${GameMode.RANKED_DUOS}`)}</h2>
            <p>{t(`game_modes_descriptions.${GameMode.RANKED_DUOS}`)}</p>
            <div className="entry-fee-badge">{t("ranked_duos_entry_fee")}</div>
            {!canPlayRankedDuos && (
              <div className="insufficient-funds">
                {t("insufficient_funds_ranked")}
              </div>
            )}
          </li>
          <li
            className="my-box"
            onClick={() => props.onSelectMode(GameMode.CLASSIC)}
          >
            <img
              src="assets/ui/game_modes/classic.png"
              alt={t(`game_modes.${GameMode.CLASSIC}`)}
              draggable="false"
            />
            <h2>{t(`game_modes.${GameMode.CLASSIC}`)}</h2>
            <p>{t(`game_modes_descriptions.${GameMode.CLASSIC}`)}</p>
          </li>
          <li
            className="my-box"
            onClick={() => props.onSelectMode(GameMode.DUOS)}
          >
            <img
              src="assets/ui/game_modes/duos.png"
              alt={t(`game_modes.${GameMode.DUOS}`)}
              draggable="false"
            />
            <h2>{t(`game_modes.${GameMode.DUOS}`)}</h2>
            <p>{t(`game_modes_descriptions.${GameMode.DUOS}`)}</p>
          </li>
          <li
            className="my-box"
            onClick={() => props.onSelectMode(GameMode.CUSTOM_LOBBY)}
          >
            <img
              src="assets/ui/game_modes/custom_lobby.png"
              alt={t(`game_modes.${GameMode.CUSTOM_LOBBY}`)}
              draggable="false"
            />
            <h2>{t(`game_modes.${GameMode.CUSTOM_LOBBY}`)}</h2>
            <p>{t(`game_modes_descriptions.${GameMode.CUSTOM_LOBBY}`)}</p>
          </li>
        </ul>
      }
    />
  )
}
